import { useState } from "react";

import Tracking from '@vromo/analytics';
import { useStore } from "@vromo/mobx-react/mobx-react";
import { RootStore } from "../../stores/RootStore";
import { useToasts } from "@vromo/ui/components/Toasts";
import Bugsnag from "@vromo/analytics/bugsnag";




/** colletions of resources for the Account top right corner tool */
export const useAccount = () => {

    const { authStore: { api, token } } = useStore<RootStore>('rootStore');
    const [oAuthToken, setOAuthToken] = useState<string>();
    const showToast = useToasts();


    const createIntegrationToken = async (group: number, client = 'dashboard-app'): Promise<string> => {

        const {
            data: authorizationCode,
            success,
            status,
            status_code
        } = await api.oAuthAuthorize.post({ group, client }, undefined, token!);

        if (!success) {
            showToast("Could not get the authorization code", "error")
            Bugsnag.notify(new Error(`Could not get the authorization code: ${status_code}, ${status}`))
            return ""
        }

        try {
            const { access_token } = await api.oAuthAccess.post(
                {
                    code: authorizationCode,
                    grant_type: 'authorization_code'
                },
                undefined,
                token!
            );

            showToast("New Integration token created",)
            setOAuthToken(access_token)
            Tracking.track('Integration token was created');
            return access_token
        }
        catch (err) {
            setOAuthToken("")
            showToast("Could not create an integration token", "error")
            Bugsnag.notify(err)
            return ""
        }
    }


    return {
        /** creates a new integration token from BE */
        createIntegrationToken,
        /** created oauth integration token */
        oAuthToken
    }
}